import * as XLSX from "xlsx";
import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";

const SalesKPI = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/agrimis");
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [productId, setProductId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };
  const [data, setData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };
  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);
  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);
  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);
  const { sendRequest: getSalesKPIData } = useHttp();

  const fillSalesKPIData = (employeeId, productId, getType = "") => {
  
    var urlfilter = "";
  
    if (showDateFilter) {
      urlfilter += `&fromDate=${selectedFromDate}`;
      urlfilter += `&toDate=${selectedToDate}`;
    }
  
    if (employeeId > 0) {
      urlfilter += `&fieldExecutiveId=${employeeId}`;
    }
    if (productId > 0) {
      urlfilter += `&productId=${productId}`;
    }
  
    if (getType !== "") {
      urlfilter += `&getType=${getType}`;
    }
  
    var url = `/api/salesKPI/?orgId=${localStorage.getItem("orgId")}&empId=${localStorage.getItem("empId")}${urlfilter}`;
  
    getSalesKPIData(
      {
        url: url,
      },
      (data) => {
        if (getType === "Excel") {
          // Excel export logic
        } else {
          setData(data);
        }
      }
    );
  };
  

  useEffect(() => {
    fillSalesKPIData(0, 0, "");
  }, [getSalesKPIData]);

  const handleExportExcel = () => {
    const filename = "SalesKPI.xlsx";
  
    if (!data || data.length === 0) {
      console.error("No data available for export.");
      return;
    }
  
    const processedData = data.map((item, index) => {
    //   const field = item.fieldDetails?.[0] || {};
    //   const product = field.fieldDetailProducts?.[0] || {};
    //   const numberOfTrainings = item.farmerDetails?.[0]
    //     ? parseInt(item.farmerDetails[0].frequencyOfTrainingToFarmer) || 0
    //     : 0;
  
      return {
        "Date": item.date || "NA",
        "Promoter Id": item.promoterId || "NA",
        "Doc No": item.docNo || "NA",
        "Agri Promoter Name": item.agriPromoterName || "NA",
        "Customer Name": item.customerName || "NA",
        "State": item.state || "NA",
        "LGA": item.lga || "NA",
        "Hub Name": item.hubName || "NA",
        "Hub Location": item.hublocation || "NA",
        "Hub State": item.hubState || "NA",
        "Product Name": item.productName || "NA",
        "Unit Abbreviation": item.unitAbbreviation || "NA",
        "Sales Quantity": item.itemQuantity || "NA",
        "Warehouse Reciept Quantity": item.warehouseQty || "NA",
        "Store Balance": item.storeBalance || "NA",
      };
    });
  
    if (processedData.length === 0) {
      console.error("Processed data is empty. Cannot export.");
      return;
    }
  
    const ws = XLSX.utils.json_to_sheet(processedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Training KPI Report");
  
    XLSX.writeFile(wb, filename);
  };
  
  
  
  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = () => {
    getEmp(
      {
        url: `/api/employeeListForTargetAllocation/?useCase=Agri Promoter&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log("emp", data);
        // var emplist = data;

        setEmployeeData(data.employeeList);
        setEmployeeAllData(data.employeeList);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getProduct } = useHttp();

  const ProductDetail = () => {
    getProduct(
      {
        url: `/api/FillAfsProductListForAgriPromoter/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log("product", data);
        // var emplist = data;

        setProductData(data);
      }
    );
  };

  useEffect(() => {
    ProductDetail(0);
  }, [getProduct]);

//   const formattedData = data.map((item) => {
//     const field = item.fieldDetails?.[0] || {};
//     const product = field.fieldDetailProducts?.[0] || {};
//     const numberOfTrainings = item.farmerDetails?.[0]
//     ? parseInt(item.farmerDetails[0].frequencyOfTrainingToFarmer) || 0
//     : 0;

//     return {
//       date: item.date,
//       employeeCode: field.employeeCode,
//       employeeName: field.employeeName,
//       docNo: item.docNo || field.docNo,
//       state: item.state,
//       lga: item.lga,
//       villageName: item.villageName,
//       trainingTopic: item.topic,
//       trainingId: item.trainingAttendanceId,
//       venue: item.venue,
//       trainingType: item.trainingType,
//       numberOfAttendees: item.fieldDetails?.length || 0,
//       numberOfTrainings: numberOfTrainings,
//       numberOfFertilizerSold: product.itemQuantity || 0,
//       unitPrice: product.itemUnitPrice || 0,
//       totalAmount: item.totalAmount || 0,
//     };
//   });

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
                Sales KPI Report
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Agri Promoter Name</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value !== "0") userid = e.target.value;
                      setData([]);
                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>Product Name</label>
                  <select
                    id="productId"
                    className="form-control"
                    ref={(el) => (frmRef.current["productId"] = el)}
                    value={productId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value !== "0") userid = e.target.value;
                      setData([]);
                      setProductId(userid);
                    }}                    
                  >
                    <option value="0">Select</option>
                    {productData &&
                      productData.map((x) => (
                        <option
                          key={x.productId}
                          user-id={x.userId}
                          value={x.productId}
                        >
                          {x.productName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillSalesKPIData(employeeId,productId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning mx-2"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>S/N</th>
                          <th>Date</th>
                          <th>Promoter Id</th>
                          <th>Agri Promoter Name</th>
                          <th>Doc No</th>
                          <th>Customer Name</th>
                          <th>State</th>
                          <th>LGA</th>
                          <th>Hub Name</th>
                          <th>Hub Location</th>
                          <th>Hub State</th>
                          <th>Product Name</th>
                          <th>Unit Abbreviation</th>
                          <th>Sales Quantity</th>
                          <th>Warehouse Reciept Quantity</th>
                          <th>Store Balance</th>
                        </tr>
                      </thead>

                      <tbody>
                        {data &&
                          data.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{i + 1}</td>
                                <td>{itm.date}</td>
                                <td>{itm.promoterId || "-"}</td>
                                <td>{itm.agriPromoterName || "-"}</td>
                                <td>{itm.docNo || "-"}</td>
                                <td>{itm.customerName || "-"}</td>
                                <td>{itm.state || "-"}</td>
                                <td>{itm.lga || "-"}</td>
                                <td>{itm.hubName || "-"}</td>
                                <td>{itm.hublocation || "-"}</td>
                                <td>{itm.hubState || "-"}</td>
                                <td>{itm.productName || "-"}</td>
                                <td>{itm.unitAbbreviation || "-"}</td>
                                <td>{itm.itemQuantity || "-"}</td>
                                <td>{itm.warehouseQty || "-"}</td>
                                <td>{itm.storeBalance || "-"}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SalesKPI;
